import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/testimonialsData';

const Testimonials = () => (
  <div className="bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="mx-auto max-w-xl text-center mb-16">
        <h2 className="text-lg font-semibold leading-8 tracking-tight text-cygnet-dark">Testimonials</h2>
        <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Trusted by leading businesses
        </p>
      </div>
      <div className="-mt-8 sm:-mx-4 sm:columns-2 sm:text-[0] lg:columns-3">
        {testimonials.map((t, i) => (
          <motion.div
            key={i}
            className="pt-8 sm:inline-block sm:w-full sm:px-4"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
          >
            <figure className="rounded-2xl bg-gray-50 p-8 text-sm leading-6">
              <blockquote className="text-gray-700 leading-relaxed">
                <p>"{t.body}"</p>
              </blockquote>
              <figcaption className="mt-6 border-t border-gray-200 pt-4">
                <div className="font-bold text-cygnet-dark">{t.company}</div>
              </figcaption>
            </figure>
          </motion.div>
        ))}
      </div>
    </div>
  </div>
);

export default Testimonials;
